import styled from 'styled-components';
import { hideVisually } from 'polished';
var StyledScreenReaderOnly = styled.span.withConfig({
  displayName: "ScreenReaderOnlystyle__StyledScreenReaderOnly",
  componentId: "sc-1of2aei-0"
})(["", ""], hideVisually());
export default StyledScreenReaderOnly;